export default "__VITE_ASSET__Dm0H0b8U__"